// @flow

import styled, { css } from 'styled-components';

export const Box = styled.div`
  ${props => props.flavor === 'simple' && css`
    background: ${props => props.theme.colors.gray(95)};
  `}

  ${props => props.flavor === 'info' && css`
    background: ${props => props.theme.colors.info(95)};
    color: ${props => props.theme.colors.secondary(20)};

    ${props => props.variation === 'light' && css`
      background: ${props => props.theme.colors.info(98)};
      color: ${props => props.theme.colors.secondary(20)};
    `}
  `}
`;
